import React from 'react'
import { useForm } from 'react-hook-form'

import { LntButton, LntForm, LntFormItem, LntModal, LntModalFooter, LntSelect, LntTextArea } from '@app/components/base'

import { getRolesDirectors } from '@app/api/routes/monitoringLists'
import { getUsersOptionsFromEntity } from '@app/utils/entitiesAdapters'

import { MONITORINGS_LISTS_KEY } from '@app/constants/queryKeys'

import { sendToApproveFormItem } from './constants'

import styles from './styles.module.scss'

import type { SendToApproveFormData, SendToApproveModalProps, SendToApproveFormProps } from './types'

const SendToApproveForm: React.FC<SendToApproveFormProps> = ({ onSendToApprove }) => {
  const formInstance = useForm<SendToApproveFormData>()

  const handleSubmit = (formData: SendToApproveFormData): void => {
    const { approverId, comment } = formData

    onSendToApprove?.({ executorUserId: approverId, comment })
  }

  return (
    <LntForm<SendToApproveFormData>
      layout='vertical'
      formInstance={ formInstance }
      onSubmit={ handleSubmit }
    >
      <LntFormItem
        label='Выберите согласующего'
        className={ styles.sendToApproveModal__formItem }
        name={ sendToApproveFormItem.APPROVER_ID }
        validationOptions={ { rules: { required: true } } }
      >
        <LntSelect
          placeholder='Пользователь'
          querySelect={ {
            queryKey: [MONITORINGS_LISTS_KEY.rolesDirectors],
            queryFn: getRolesDirectors,
            select: getUsersOptionsFromEntity
          } }
        />
      </LntFormItem>

      <LntFormItem
        label='Напишите комментарий'
        name={ sendToApproveFormItem.COMMENT }
      >
        <LntTextArea placeholder='Ваш текст' />
      </LntFormItem>

      <LntModalFooter>
        <LntButton
          htmlType='submit'
          disabled={ !formInstance.formState.isValid }
        >
          Отправить
        </LntButton>
      </LntModalFooter>
    </LntForm>
  )
}

export const SendToApproveModal: React.FC<SendToApproveModalProps> = ({ open, onCancel, onSendToApprove }) => {
  return (
    <LntModal
      title='Отправить на согласование'
      className={ styles.sendToApproveModal }
      footer={ null }
      open={ open }
      onCancel={ onCancel }
    >
      <SendToApproveForm onSendToApprove={ onSendToApprove } />
    </LntModal>
  )
}
